import { createContext, useContext, useEffect, useState } from "react";

// مقارنة العروض — حتى 3 عروض، تُحفظ محليًا، بلا إرسال أو حفظ في قاعدة البيانات
const CompareContext = createContext(null);
const KEY = "tg_offer_compare_v1";

export const CompareProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch { /* ممتلئة */ }
  }, [items]);

  const has = (id) => items.some((o) => o.id === id);
  const toggle = (offer) => {
    setItems((cur) => {
      if (cur.some((o) => o.id === offer.id)) return cur.filter((o) => o.id !== offer.id);
      if (cur.length >= 3) return cur;
      return [...cur, offer];
    });
  };
  const clear = () => setItems([]);

  return (
    <CompareContext.Provider value={{ items, has, toggle, clear, open, setOpen }}>
      {children}
    </CompareContext.Provider>
  );
};

export const useOfferCompare = () => useContext(CompareContext);
